import { IconButton } from '@mui/material';
import React from 'react';

export const DEBUGGING_WIDGET_ID = 'debugging-layers-widget';

export default function DebuggingLayersWidget({ onClick } : { readonly onClick: () => void }) {
  return (
    <IconButton
      className="esri-component esri-widget--button esri-widget"
      sx={{ borderRadius: 0 }}
      onClick={onClick}
      title="Dump layers to console"
      id={DEBUGGING_WIDGET_ID}
    >
      <span
        data-testid="esri-icon-layers"
        className="esri-icon esri-icon-zoom-out-fixed"
      />
    </IconButton>
  );
}
